
import { createContext } from 'react'

//esto es  un useContent los datos se usaran en toda la heraquia de componente

export const AuthContext = createContext();